var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgColorFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63755 22.0494L0.75 13.1302L11.181 2.66204L20.0668 11.5795L9.63755 22.0494ZM3.84058 13.1301L9.63593 18.9461L16.9783 11.5794L11.1812 5.76341L3.84058 13.1301Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63735 19.7222L3.06873 13.1302L4.12569 11.5331H17.2393L9.63735 19.7222Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0234 1.5L11.9546 3.43979L10.4092 4.99061L8.47804 3.05082L10.0234 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2955 10.8048L21.2267 12.7429L19.6814 14.2937L17.7502 12.3556L19.2955 10.8048Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 20.0324C23.25 21.6981 21.4059 22.5 20.7912 22.5C20.4155 22.5 18.3324 21.6981 18.3324 20.0324C18.3324 18.3668 20.3353 15.9661 20.7912 15.9198C21.1566 15.8838 23.25 18.3668 23.25 20.0324Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColorFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/color-fill.a8ebb8cdab8f10285fae32ae86d29bac.svg";